import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledOverlay = styled.div `
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
export const Overlay = ({ children, showOverlay, onClick }) => {
    const handleClick = (e) => {
        if (e.target !== e.currentTarget)
            return;
        if (onClick)
            onClick();
    };
    if (showOverlay) {
        return (_jsx(StyledOverlay, { onClick: handleClick, children: children }));
    }
    return _jsx(_Fragment, { children: children });
};
